/* eslint-disable jsx-a11y/anchor-is-valid */
import { useLocation, useNavigate } from "react-router-dom";
// import CustomerTable from "./CustomerTable";


import { useCallback, useContext, useEffect, useState } from "react";

import RestartAlt from '@mui/icons-material/RestartAlt';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { voucherService } from "../../services/voucherService";
import { GetVoucherListAtom, SetVoucherListAtom } from "../../store/voucherAtom";
import Tooltip from "@mui/material/Tooltip";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import { formatCustomDate } from "../../helpers/formatCustomDate";
import { useForm } from "react-hook-form";
import LogicContext from "../../Context/LogicContext";
import moment from "moment";





const columns = [
  {
    title: 'Ref',
    key: 'Corporate_Ref_No',
    dataIndex: 'Corporate_Ref_No',
  className: "text-primary",
  sorter: (a, b) => (a?.Corporate_Ref_No ?? '') - (b?.Corporate_Ref_No ?? '')
  },

  {
    title: ' Date',
    // key: 'id',
    dataIndex: 'Voucher_Date',
  sorter: (a, b) => (a?.Voucher_Date ?? '').localeCompare(b?.Voucher_Date ?? ''),
  render: (record) => <span> {formatCustomDate(record)} </span>

  },
    
  {
    title: "Corporate Name",
    dataIndex: "Corporate_Name",
    sorter: (a, b) => (a?.Corporate_Name ?? '').localeCompare(b?.Corporate_Name ?? '')

  },

  {
    title: "Voucher Quantity",
    dataIndex: "Voucher_Quantity",
  sorter: (a, b) => (a?.Voucher_Quantity ?? '') - (b?.Voucher_Quantity ?? ''),
    render: (record) => <span> {formatCustomNumber(record)} </span>

  },
  {
    title: "Amount/Voucher (₦)",
    dataIndex: "Voucher_Value",
  sorter: (a, b) => (a?.Voucher_Value ?? '') - (b?.Voucher_Value ?? ''),
    render: (record) => <span> {formatCustomNumber(record)} </span>

  },
  {
    title: "Total Amount (₦)",
    dataIndex: "Total_Voucher_Amount",
  sorter: (a, b) => (a?.Total_Voucher_Amount ?? '') - (b?.Total_Voucher_Amount ?? ''),
    render: (record) => <span> {formatCustomNumber(record)} </span>

  },
  {
    title: "Created By",
    dataIndex: "Created_By_Name",
    sorter: (a, b) => (a?.Created_By_Name ?? '').localeCompare(b?.Created_By_Name ?? '')

  },


];


function VoucherCorporateMainPage() {
  const { pathname } = useLocation();
  const getVoucherList = GetVoucherListAtom();
  const setVoucherList = SetVoucherListAtom();
  const navigate = useNavigate();
  var url = pathname.split('/')
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
   const { register, getValues, formState: { errors }} = useForm();
         const logicContext = useContext(LogicContext);
         const [voucherFilteredList, setVoucherFilteredList] = useState([]);
   


  useEffect(() => {
    document.title = 'Voucher Purchase';
    if (getVoucherList.voucher_info.length < 1) {
      loadVoucherData();
    }else{
      setVoucherFilteredList(getVoucherList.voucher_info);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const reloadData = () => {
    loadVoucherData();
  }


  const loadVoucherData = () => {
    voucherService.getCorporateVoucherList().then(res => {
      if (res.data?.voucher_info?.length) {
        setVoucherList({...res?.data, newVoucherList:[]});
        setVoucherFilteredList(res?.data.voucher_info);
      }
    });
  }

  function addNew() {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`)
  }


  function handleRowClick(voucher){
    const id = voucher['Corporate_Ref_No'];
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
}


 // Searches for manual journals by date range.
  const searchByDate = async (event) => {
    const formData = getValues();
    const response = await voucherService.getCorVoucherByDate(formData);
    if(response?.data?.length){
      setVoucherFilteredList(response.data);
      
    }else{
      setVoucherFilteredList([]);
      logicContext.showToast(
        "No available record for your search query!",
        ""
      );
    }
  };




  return (

    <>
      <Grid container >
     
      </Grid>

         <div className="flex flex-col gap-6 p-6 bg-gray-50 rounded-lg shadow-sm z-10">
        {/* Top Controls: Reload, Date Search, Type Select, and Add New */}
        <div className="flex flex-wrap items-center justify-between gap-4">
          {/* Left Side: Reload + Date Search + Type Select */}
          <div className="flex items-center gap-4">
            {/* Reload Button */}
            <Tooltip title="Reload">
              <RestartAlt
                className="cursor-pointer text-blue-600 hover:text-blue-800 transition-colors self-center"
                onClick={() => reloadData()}
                color="primary"
                fontSize="large"
              />
            </Tooltip>
      
            {/* Date Range Search */}
            <div className="flex items-center gap-3">
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700">From Date</label>
                <input
                  defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                  {...register("fr_date")}
                  type="date"
                  className="mt-1 mb-2 h-10 w-80 bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all z-10"
                />
              </div>
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700">To Date</label>
                <input
                  defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                  {...register("to_date")}
                  type="date"
                  className="mt-1 mb-2 h-10 w-80 bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all  z-10"
                />
              </div>
         
              <button
                onClick={() => searchByDate()}
                type="button"
                className="mt-1 h-10 bg-blue-600 text-white text-sm font-medium rounded-md px-4 py-2 hover:bg-blue-700 transition-colors"
              >
                Search
              </button>
            </div>
          </div>
      
          {/* Right Side: Add New Button */}
          <div className="flex items-center gap-4">
            <button
              onClick={() => addNew()}
              className="mt-1 h-10 bg-blue-600 text-white text-sm font-medium rounded-md px-4 py-2 hover:bg-blue-700 transition-colors"
            >
              Add New
            </button>
          </div>
        </div>
      
        {/* Data Count */}
        <div className="flex items-center">
         
        </div>
      </div>
            {/* End */}


        <section className="mt-5">
          <GeneralCustomTable
              tableHeadList={columns} 
              tableDataList={voucherFilteredList}
              allowCheckBox={false} // show checkBox for each row
              setSelectedRows={(sel)=> console.log(sel) }
              rowKey={(record) => record.Corporate_Ref_No} // custom key
              handleRowClick={handleRowClick} />
           </section>
    </>

  );
}

export default VoucherCorporateMainPage;
